export const TERMS_AND_CONDITIONS_URL = "https://fieldproapp.com/terms/";
export const PRIVACY_POLICY_URL = "https://fieldproapp.com/privacypolicy/";
export const SUPPORT_ADRESSE_EMAIL = "support@optimetriks.com";
